<template>
  <div id="app">
    <p ref="printMe">
      <span>{{ this.driver }}</span>
      gets <span>{{ this.penalty }} </span> after<br />
      <span>{{ this.reason }} </span>
    </p>

    <div class="actions">
      <button @click="generate()" class="black">Regenerate</button>
      <a target="_blank" href="https://twitter.com/intent/tweet?source=webclient&text=Yo, @SmiddyBurbon, you should add this to the post-race penalty generator: ">Suggest something &#128140;</a>
      <!--<button @click="tweet()" class="blue">Tweet</button>-->
    </div>

    <img :src="output">
  </div>
</template>

<script>
export default ({
  data: function() {
    return {
      output: null,
      driver: '',
      penalty: '',
      reason: '',
      drivers: [
        'Pascal Wehrlein',
        'Andre Lotterer',
        'Lucas di Grassi',
        'Rene Rast',
        'Nick Cassidy',
        'Sam Bird',
        'Robin Frijns',
        'Mitch Evans',
        'Antonio Felix da Costa',
        'Jean-Eric Vergne',
        'Nyck de Vries',
        'Stoffel Vandoorne',
        'Nico Müller',
        'Sebastien Buemi',
        'Oliver Rowland',
        'Sergio Sette Camara',
        'Tom Blomqvist',
        'Oliver Turvey',
        'Alex Lynn',
        'Alexander Sims',
        'Edoardo Mortara',
        'Norman Nato',
        'Maximilian Günther',
        'Jake Dennis',
      ],
      penalties: [
        'a 5 second time penalty',
        'a 10 second time penalty',
        'no permission to start',
        'disqualified before the race',
        'disqualified 4 minutes after the race',
        'disqualified 2 days after the race',
        'disqualified 9 races after the race',
        'disqualified 3 hours after the race',
        'disqualified 3 seconds after the race',
        'a 10 second stop & go',
        'a 3 place grid penalty for the next race',
        'a 3 place grid penalty for the next race despite it being the end of the season',
        'a 5 place grid penalty for the next race',
        'a 32 place grid penalty for the next race',
        'a 64 place grid penalty for the next race',
        'a 128 place grid penalty for the next race',
        'a 256 place grid penalty for the next race',
        'a 4.99£ fine',
        'a 500£ fine',
        'a 2,500£ fine',
        'a 5,000£ fine',
        'a 500,000£ fine',
        'a 1,000,000£ fine',
        'no penalty',
        'a suspended three-race ban',
        'his FIA license revoked',
      ],
      reasons: [
        'his team logged a 9 instead of an 8 on the right rear tyre.',
        'his team failed to declare the allocation of their tyres on their technical passports.',
        'his team failed to submit the chassis number before qualifying.',
        'his race engineer failed to submit the ID of his headphones before first practice.',
        'exceeding maximum power by 0.1 kW for 0.2 seconds.',
        'exceeding track limits on the final corner of the final lap with a 9.8 second lead.',
        'failing to keep 1.5 metres distance in the media pen.',
        'his car was found underweight.',
        'not using maximum power during Fanboost.',
        'using a ringer in his place at a non-championship e-sports event the week prior.',
        'losing the inside label of his right glove during the race.',
        'failing to arm Attack Mode in Free Practice 2.',
        'jumping his practice start after FP1.',
        'failing to arm Attack Mode on lap 23.',
        'using his team radio on the starting grid.',
        'his team shipped in a spare front wing with UPS rather than DHL for the second race of the double-header.',
        'using black fireproof underwear while his team only logged white fireproof underwear.',
        'tearing off 3 metres of advertising boards while racing three-wide into turn 9.',
        'not being able to take his second Attack Mode due to a surprise Safety Car.',
        'having too many colours on his helmet design.',
        'not appearing to do media duties.',
        'losing his 3rd placed WDC trophy in New York.',
        'causing a collision.',
        'an unregulatory underwear offence.',
      ],
      randoms: [
        0, 0, 0
      ]
    }
  },
  methods: {
    generate: function() {
      this.randoms[0] = Math.ceil(Math.random() * this.drivers.length-1);
      this.randoms[1] = Math.ceil(Math.random() * this.penalties.length-1);
      this.randoms[2] = Math.ceil(Math.random() * this.reasons.length-1);
      this.populate(this.randoms[0], this.randoms[1], this.randoms[2])
      console.log(this.randoms)
    },
    populate: function(driver, penalty, reason) {
      this.driver = this.drivers[driver],
      this.penalty = this.penalties[penalty],
      this.reason = this.reasons[reason]
    },
    async print() {
      const el = this.$refs.printMe;
      // add option type to get the image version
      // if not provided the promise will return 
      // the canvas.
      const options = {
        type: 'dataURL'
      }
      this.output = await this.$html2canvas(el, options);
    }
  },
  beforeMount: function() {
    this.generate();
  },
  head: {
    title: {
      inner: 'Post-Race Penalty Generator'
    },
    meta: [
      {name: 'twitter:card', content: 'summary_large_image'},
      {name: 'twitter:title', content: 'Formula E Post-Race Penalty Generator'},
      {name: 'twitter:url', content: 'https://post-race-penalties.vercel.app/'},
      {name: 'twitter:description', content: 'Formula E Post-Race Penalty Generator'},
      {name: 'twitter:image', content: 'http://www.dennisschmidt.net/post-race_1.png'} 
    ],
    script: [
      { src: 'https://platform.twitter.com/widgets.js', async: true },
    ]
  }
})
</script>


<style>
@import url('https://fonts.googleapis.com/css2?family=Rubik:wght@300;500&display=swap');

:root {
  --cyan: #14B7ED;
  --black: #31333C;
  --white: #FFF;
  --body-font: 'Rubik', Helvetica, Arial, sans-serif;
}

* {
  box-sizing: border-box;
}

body {
  background-color: var(--white);
  overflow: hidden;
  padding: 3rem 0;
  margin: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

#app {
  height: 100vh;
  width: 61.8vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: var(--body-font);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--black);
  font-size: 2rem;
  font-weight: 300;
}

p {
  text-align: center;
  line-height: 1.4;
  background-color: var(--cyan);
  color: var(--white);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 3rem;
}
span {
  font-weight: 500;
}
.actions {
  flex-direction: column;
  display: flex;
}
button {
  background-color: var(--cyan);
  color: var(--white);
  font-size: 1.5rem;
  padding: 0.5rem 2rem;
  outline: none;
  border: none;
  box-shadow: none;
  font-family: var(--body-font);
  margin: 0 1rem;
  transition: .2s ease-in-out;
  transition-delay: .08s;
  cursor: pointer;
}
button.black {
  background-color: var(--black);  
}
a {
  background: none;
  color: var(--cyan);
  font-size: 1rem;
  margin-top: 1.5rem;
  text-decoration: none;
  font-weight: 500;
  text-align: center;
}
a:hover {
  filter: brightness(1.2);
}
button:hover {
  filter: brightness(1.8);
}

@media screen and (max-width: 640px) {
  #app {
    width: 90vw;
  }
  p, button {
    font-size: 1.5rem;
  }
}
</style>
